export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCSESS = "LOGIN_SUCSESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS" ;
export const DEALER_AUTH = "DEALER_AUTH";
export const LOGOUT = "LOGOUT";